import { render, staticRenderFns } from "./SettingsImportSection.vue?vue&type=template&id=5cf8c6d4"
import script from "./SettingsImportSection.vue?vue&type=script&lang=js"
export * from "./SettingsImportSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports